sessionStorage.removeItem('cart_note');

let currentCart = null;

const removeChars = (text) =>{
  text = text.replace(/,/g, ' ');
  text = text.replace(/-/g, ' ');
  return text;
}

const formatAddress = (event) =>{
  $btnFired = $(event.target),
  $formEl = $btnFired.parents('form'),
  $address1El = $formEl.find('[name="address[address1]"]'),
  $numberEl = $formEl.find('[name="address[number]"]'),
  $districtEl = $formEl.find('[name="address[district]"]');

  $formatedAddress = `${removeChars($address1El.val())},${removeChars($numberEl.val())},${removeChars($districtEl.val())}`;

  $address1El.val($formatedAddress);

  $formEl.find('[type="submit"]').click();
}

const updateAddressByZip = (evt) => {
  var $btn = $(evt.target),
      $form = $btn.closest('form'),
      zipValue = $btn.val().replace('-', '').trim();

  if (zipValue != '') {
      $.getJSON(`//viacep.com.br/ws/${zipValue}/json?callback=?`, function (response) {
          $form.find('[name*="[district]"]').val(response.bairro);
          $form.find('[name*="[province]"]').val(response.uf);
          $form.find('[name="address[address1]"]').val(response.logradouro);
          $form.find('[name="address[city]"]').val(response.localidade);
      });
  }
}

(function () {
  "use strict";

  const custom = {
    //Valida a escolha do presente 'Sim' ou 'Não'
    presentsYesNo() {
      $("#cart-presents .cart-itens li").on("click", function () {
        $("#cart-presents .cart-itens li").removeClass("active");
        $(this).addClass("active");

        if ($(this).hasClass("yes")) {
          $(".content-presents").fadeIn();
          $("#nome_de").focus();
          $(this)
            .closest(".cart-presents-item")
            .find(".msg_presents")
            .fadeOut();
          sessionStorage.setItem("presente", "Sim");
        } else {
          $(".content-presents").fadeOut();
          $(".info_dados").removeClass("error").val("");
          $(".info_dados").removeClass("success").val("");
          $(this).closest(".cart-presents-item").find(".msg_presents").fadeIn();
          sessionStorage.setItem("presente", "Não");
          sessionStorage.setItem("retirada", "Não");
        }
      });
      setTimeout(() => {
        $("#cart-presents .cart-itens li.yes").click()
      }, 500)
    },

    //Contador de caracteres do campo mensagem
    counterChar() {
      $(".caracteres, .caracteres .first, .caracteres .last").css(
        "color",
        "#DADADA"
      );
      $("#limiteCaracteres").on("keyup", function () {
        let limite = 598;
        let caracteresDigitados = $(this).val().length;
        if (caracteresDigitados >= limite) {
          $(".caracteres, .caracteres .first, .caracteres .last").css(
            "color",
            "#FFD26B"
          );
        } else {
          $(".caracteres , .caracteres .first, .caracteres .last").css(
            "color",
            "#DADADA"
          );
        }
        $(".caracteres .first").text(caracteresDigitados);
      });
    },

    changeFields() {
      $(".info_dados").on("blur", function () {
        return $(this).val() == ""
          ? $(this).addClass("error")
          : $(this).addClass("success");
      });

      $("#anonimo").on("change", function () {
        let elAnonimoDisabled = $('.itemDe [name="info_dados"]');

        if ($(this).prop("checked") == true) {
          $("#nome_de").val("");
          $("#sobrenome_de").val("");
          $(elAnonimoDisabled).removeClass("error");
          $(elAnonimoDisabled).prop("disabled", true);
          $(".itemDe").css("opacity", "0.5");
        } else {
          $(elAnonimoDisabled).prop("disabled", false);
          $(".itemDe").css("opacity", "1");
        }
      });
    },

    //Valida o checkebox termos e condições
    termsConditions() {
      $("#checkout")
        .prop("disabled", true)
        .css({ opacity: "0.2", cursor: "inherit" });

      $("#termos #termosCondicoes").on("change", function () {
        if ($(this).prop("checked") == true) {
          $("#checkout").css({ opacity: "1", cursor: "pointer" });
          $("#checkout").prop("disabled", false);
        } else {
          $("#checkout").css({ opacity: "0.2", cursor: "inherit" });
          $("#checkout").prop("disabled", true);
        }
      });
    },

    //Valida todos so campos do formulario de presente
    validateFieldsPresents() {
      $("#checkout").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();
        let continueCheckout = true;
        if ($(".cart-itens .yes").hasClass("active")) {
          console.log("CLICOU EM SIM!");

          if (!$("#anonimo").is(":checked")) {
            if ($("#nome_de").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo nome do remetente",
              });
              $("#nome_de").focus();
              continueCheckout = false;
            } else if ($("#sobrenome_de").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo sobrenome do remetente",
              });
              $("#sobrenome_de").focus();
              continueCheckout = false;
            } else if ($("#nome_para").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo nome do destinatário",
              });
              $("#nome_para").focus();
              continueCheckout = false;
            } else if ($("#sobrenome_para").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo sobrenome do destinatário",
              });
              $("#sobrenome_para").focus();
              continueCheckout = false;
            } else if ($("#limiteCaracteres").val() == "") {
              Swal.fire({ icon: "error", title: "Preencha o campo mensagem" });
              $("#limiteCaracteres").focus();
              continueCheckout = false;
            } else if ($("#destinatario_telefone").val() == "") {
              Swal.fire({ icon: "error", title: "Preencha o campo telefone" });
              $("#destinatario_telefone").focus();
              continueCheckout = false;
            } else if ($("#destinatario_telefone_presenteado").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo telefone presenteado",
              });
              $("#destinatario_telefone_presenteado").focus();
              continueCheckout = false;
            } else if (
              $("#destinatario_telefone_presenteado").val() ==
              $("#destinatario_telefone").val()
            ) {
              Swal.fire({
                icon: "error",
                title:
                  "Campo telefone de destinatario não pode ser igual ao seu telefone",
              });
              $("#destinatario_telefone_presenteado").focus();
              continueCheckout = false;
            }
          } else {
            if ($("#nome_para").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo nome do destinatário",
              });
              $("#nome_para").focus();
              continueCheckout = false;
            } else if ($("#sobrenome_para").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo sobrenome do destinatário",
              });
              $("#sobrenome_para").focus();
              continueCheckout = false;
            } else if ($("#limiteCaracteres").val() == "") {
              Swal.fire({ icon: "error", title: "Preencha o campo mensagem" });
              $("#limiteCaracteres").focus();
              continueCheckout = false;
            } else if ($("#destinatario_telefone").val() == "") {
              Swal.fire({ icon: "error", title: "Preencha o campo telefone" });
              $("#destinatario_telefone").focus();
              continueCheckout = false;
            } else if ($("#destinatario_telefone_presenteado").val() == "") {
              Swal.fire({
                icon: "error",
                title: "Preencha o campo telefone presenteado",
              });
              $("#destinatario_telefone_presenteado").focus();
              continueCheckout = false;
            } else if (
              $("#destinatario_telefone_presenteado").val() ==
              $("#destinatario_telefone").val()
            ) {
              Swal.fire({
                icon: "error",
                title:
                  "Campo telefone de destinatario não pode ser igual ao seu telefone",
              });
              $("#destinatario_telefone_presenteado").focus();
              continueCheckout = false;
            }
          }

          getDadosPresents();
        }
        if(continueCheckout){
          updateCartProperties()
        }
      });
    },

    //Cria uma mascara nos campos de telefone
    FieldsMask() {
      $("#destinatario_telefone").mask("00000-000");
      $("#destinatario_telefone_presenteado").mask("00000-000");
      let behavior = function (val) {
          return val.replace(/\D/g, "").length === 11
            ? "00 00000-0000"
            : "00 0000-00009";
        },
        options = {
          onKeyPress: function (val, e, field, options) {
            field.mask(behavior.apply({}, arguments), options);
          },
        };
      $("#destinatario_telefone").mask(behavior, options);
      $("#destinatario_telefone_presenteado").mask(behavior, options);
    },

    validadeNewletter() {
      $(".msg-news").css("display", "none");
      $("#footer-subscribe").on("click", function () {
        if ($('[name="contact[email]"]').val() == "") {
          $(".msg-news").css("display", "block").delay("1500").fadeOut("1500");
          return false;
        }
      });
    },
    checkModalForgotPass() {
      if(window.location.href.indexOf('/login') > -1){
        if($('.return-msg-recover')[0]){
          $('[data-src="#recover-password"]').click()
        }
      }
      if(window.location.href.indexOf('/account/invalid_token') > -1){
        if($('.customer-login .errors')[0]){
          $('.errors p').html('Período do token expirado, inicie o processo de esqueci minha senha novamente!')
        }else{
          $('.customer-login').prepend(`<div class="desktop-12 tablet-6 mobile-3">
                
            <div class="errors note note-error mb3 inline-block">
              <p class="sm-caps inline-block v-center mb0">Período do token expirado, inicie o processo de esqueci minha senha novamente!</p>
            </div>
          
        </div>`)
        }
      }
    },
    AddressMask() {
      if(window.location.href.indexOf('/account') > -1){
        if($('[name="address[zip]"]')[0]){
          $('[name="address[zip]"]').mask('00000-000')
        }
        if($('[name="address[company]"]')[0]){
          let behaviorDoc = function (val) {
            return val.replace(/\D/g, "").length > 11
              ? "00.000.000/0000-00"
              : "000.000.000-009";
          },
          optsDoc = {
            onKeyPress: function (val, e, field, options) {
              field.mask(behaviorDoc.apply({}, arguments), options);
            },
          };
          $('[name="address[company]"]').mask(behaviorDoc, optsDoc);
        }
        if($('[name="address[phone]"]')[0]){
          let behaviorPhone = function (val) {
            return val.replace(/\D/g, "").length === 11
              ? "00 00000-0000"
              : "00 0000-00009";
          },
          optsPhone = {
            onKeyPress: function (val, e, field, options) {
              field.mask(behaviorPhone.apply({}, arguments), options);
            },
          };
          $('[name="address[phone]"]').mask(behaviorPhone, optsPhone);
        }
      }
    }
  };

  $(function () {
    custom.presentsYesNo();
    custom.counterChar();
    custom.changeFields();
    custom.termsConditions();
    custom.validateFieldsPresents();
    custom.FieldsMask();
    custom.validadeNewletter();
    custom.checkModalForgotPass();
    custom.AddressMask()

    if(window.location.href.indexOf('/cart') > -1){
      $.getJSON('/cart.js', (cart) => {
        currentCart = cart;
      })
    }

    //Carrega a página e grava a session com o valor 'Não'
    if ($("#cart-presents").length) {
      sessionStorage.setItem("presente", "Não");
      sessionStorage.setItem("retirada", "Não");
    }
    //Verifica se tem a class active e se o usuario escolheu opção 'Não' - remove a session
    if ($(".cart-itens .no").hasClass("active")) {
      if (sessionStorage.getItem("presente") == "Não") {
        sessionStorage.removeItem("lista");
      }
    }

    //Limpa os dados gravados na session
    sessionStorage.removeItem("schedule-token");
    sessionStorage.removeItem("schedule_date_thankyou");
    sessionStorage.removeItem("proceedToCheckout");
    sessionStorage.removeItem("schedule_date");
    //sessionStorage.removeItem('lista');
    //sessionStorage.removeItem('retirada');
    sessionStorage.removeItem("Entrega_local");
  });
})();

let propsGift;

let updateGiftOnNote = function () {
  debugger;
  propsGift = {
    'Presente': true
  };
  let senderName = $("#nome_de").val() + ' ' + $('#sobrenome_de').val();
  let recipientName = $("#nome_para").val() + ' ' + $('#sobrenome_para').val();
  let recipientPhone = $("#destinatario_telefone").val();
  let giftedPhone = $("#destinatario_telefone_presenteado").val();

  
  let msgNote = $("#limiteCaracteres").val();
  let msgAnonimoNote = $("#anonimo");
  let msnInfo = $(".vantage-accordion #note").val();
  let updateNoteMensagem = "";

  

  //debugger;
  //executa apenas se um dos campos teve alteracao
  
  if (senderName.trim() != "") {
    updateNoteMensagem += "\n **** NOME DO REMETENTE: " + senderName;
    propsGift['NOME DO REMETENTE'] = senderName
  }
  if (recipientName.trim() != "") {
    updateNoteMensagem += "\n **** NOME DO DESTINATÁRIO: " + recipientName;
    propsGift['NOME DO DESTINATÁRIO'] = recipientName
  }
  if (recipientPhone.trim() != "") {
    updateNoteMensagem += "\n **** SEU TELEFONE: " + recipientPhone;
    propsGift['SEU TELEFONE'] = recipientPhone
  }
  if (giftedPhone.trim() != "") {
    updateNoteMensagem += "\n **** TELEFONE DO PRESENTEADO: " + giftedPhone;
    propsGift['TELEFONE DO PRESENTEADO'] = giftedPhone;
  }


  if (msgNote.trim() != "") {
    updateNoteMensagem += "\n **** MENSAGEM: " + msgNote;
    propsGift['MENSAGEM'] = msgNote;
  }

  if ($(msgAnonimoNote).prop("checked")) {
    let resAnonimo = "SIM";
    updateNoteMensagem += "\n *** ANÔNIMO: " + resAnonimo;
    propsGift['ANÔNIMO'] = resAnonimo;
  }

  if (msnInfo.trim() != "") {
    updateNoteMensagem += "\n *** OBSERVAÇÃO: " + msnInfo;
    propsGift['OBSERVAÇÃO'] = msnInfo;
  }
debugger
  $.ajax({
    url: "/cart/update.js",
    dataType: "json",
    data: {
      note: updateNoteMensagem,
      // note: "Nome do remetente:" + senderName +  " - Nome do Destinatário:" + recipientName +  " - Seu telefone:" + recipientPhone +  " - Telefone do presenteado:" + giftedPhone +   updateNoteMensagem,
    },
  }).done(function (response) {
    console.log("RESPONSE", response);
    $('[name="note"]').val(response.note);
    sessionStorage.setItem('cart_note', updateNoteMensagem);
  });
};

const updateCartProperties = () => {
//adiciona properties no carrinho

  //valida se ja tem algum item com propertie
  const itemProp = currentCart.items.find( x => { return x.properties != null && x.properties.Presente == 'true'});
  const isGift = $('.cart-itens .yes').hasClass('active');
  let itemChange = null;
  debugger;
  if(isGift){
    if(itemProp){
      itemChange = {
        id: itemProp.key,
        properties: propsGift
      }
    }else{
      itemChange = {
        line: 1,
        properties: propsGift
      }
    }
    $.post(window.location.origin + '/cart/change.js',
      itemChange,
      function(response) {
        window.location.href = '/checkout';
      },
    'json');
  }else{
    if(itemProp){

      $.post(window.location.origin + '/cart/change.js',
        {
          id: itemProp.key,
          quantity: 0
        },
        function(response) {
          debugger;
          $.ajax({
            url: "/cart/add.js",
            method: 'POST',
            data: {
              items: [
                {
                  id: itemProp.id,
                  quantity: itemProp.quantity
                }
              ]
            },
            dataType: 'json'
          }).done(function (response) {
            window.location.href = '/checkout'
          });
        },
      'json');
    }else{
      window.location.href = '/checkout';
    }
  }

  /*const itensChange = [];
  const sendProps = [];
  $.each(currentCart.items, (idx, item) => {
    // if (item.properties && !item.properties['Presente']){
    //   $.each(item.properties, (i, prop) => {
    //     sendProps.push(item.properties)
    //   })
    // }
    // sendProps.push(propsGift);
    itensChange.push({
      id: item.id,
      quantity: item.quantity,
      properties: propsGift
    })
    debugger
  })
  $.post( "/cart/clear.js", function( data ) {
    $.ajax({
      url: "/cart/add.js",
      method: 'POST',
      data: {items: itensChange},
      dataType: 'json'
    }).done(function (response) {
      console.log("RESPONSE", response);
    });
  }, "json");*/
}

let getDadosPresents = function () {
  sessionStorage.removeItem("lista");

  let name = $("#nome_para").val();
  let lastName = $("#sobrenome_para").val();
  let phone = $("#destinatario_telefone_presenteado").val();
  let phoneSender = $("#destinatario_telefone").val();
  let dados = JSON.parse(sessionStorage.getItem("lista") || "[]");

  // Adiciona dados ao cadastro
  let auxRegistro = {
    name: name,
    lastName: lastName,
    phone: phone
  };
  dados.push(auxRegistro);

  // Salva a lista alterada
  sessionStorage.setItem("lista", JSON.stringify(dados));
  sessionStorage.setItem("phoneSender", phoneSender);
};
